import { TemplatePlaceholder } from '@/types';
import TemplateCapableFetchAutocomplete from '@/components/TemplateCapableFetchAutocomplete';
import { SearchTemplatePageContext } from '@/context/SearchTemplateContext';
import { useContext } from 'react';
import { PARTICIPANT_STATUSES_WITH_IDS } from '@/constants/filterCriteria/eventParticipants';
import { EventParticipantRecordResult } from '@/types/filterCriteriaRecords';

type EventParticipantProps = {
  onChange: (newValue: EventParticipantRecordResult[] | TemplatePlaceholder) => void;
  value: EventParticipantRecordResult[] | TemplatePlaceholder;
  isAdvancedSearch?: boolean;
};

const EventParticipants = ({
  value = [] as EventParticipantRecordResult[],
  onChange = () => {},
  isAdvancedSearch,
}: EventParticipantProps) => {
  const inSearchTemplate = useContext(SearchTemplatePageContext);
  return (
    <TemplateCapableFetchAutocomplete
      sx={isAdvancedSearch ? { width: '45ch' } : {}}
      minLength={0}
      label="Participant status(es) (optional)"
      preLoadedOptions={PARTICIPANT_STATUSES_WITH_IDS}
      value={value}
      onChange={(newValue) => onChange(newValue)}
      loadingText="Looking for participant statuses..."
      noOptionsText="No participant statuses found"
      isOnTemplatePage={inSearchTemplate}
      templateBuilderDisplayName="Event attendance filter: Participant status"
    />
  );
};

export default EventParticipants;
